import { daySegments, daysOfWeek } from 'config/common.config';

export const getSelectedWaveAndWindWeekday = (dayOfWeekNum) => {
  const selectedIndex = Number.isInteger(dayOfWeekNum) ? dayOfWeekNum : new Date().getDay();

  return daysOfWeek[selectedIndex] ?? daysOfWeek[new Date().getDay()];
};

export const getWaveAndWindWeekdayEntries = (marineEntries = [], selectedWeekday) => {
  return marineEntries.filter((entry) => entry.weekday === selectedWeekday);
};

export const getWaveAndWindSegmentEntries = (weekdayEntries = []) => {
  return daySegments.map((segment) => {
    return weekdayEntries.find((entry) => entry.day_segment === segment) ?? null;
  });
};
